import { Flex } from 'components/Flex';
import styled from 'styled-components';

export const SeniorityRankingContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  width: 65%;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-bottom: 24px;
`;

export const FlexWrapper = styled(Flex)`
  background-color: white;
`;

export const SubHeader = styled.div`
  color: ${({ theme }) => theme.colors.AccentPurple};
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
`;

export const LastChangedFooter = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-size: 14px;
  line-height: 21px;
  padding-top: 10px;
  margin-bottom: 24px;
`;

export const SeniorityRankingInfo = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.Grey1};
  width: 100%;
  padding: 12px 16px 12px 12px;
  align-items: center;
  height: 72px;

  border-top: 1px solid ${({ theme }) => theme.colors.Grey5};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
`;

export const SeniorityRankingInfoColumn = styled(Flex)`
  flex: 1;
  height: 100%;
  align-items: center;

  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => theme.fonts.Poppins};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;
